import { Label } from '../../TypographyNew';
import { getAbsoluteWidth } from '../PlanUsage.utils';
import { TPlanUsageInterval } from '../PlanUsage.type';
import React, { FC } from 'react';
import styled from 'styled-components';

export const MarkContainer = styled.span<{ left: string; white: boolean }>`
  width: var(--spacing-s);
  height: var(--spacing-s);
  border-radius: var(--radius-100);
  background: ${(p) =>
    p.white
      ? 'var(--color-interface-neutral-light)'
      : 'var(--color-interface-content-normal)'};
  z-index: 3;
  flex-shrink: 0;
  position: absolute;
  left: calc(${(p) => p.left} - calc(var(--spacing-xxs) * 2));

  > p {
    position: absolute;
    margin-top: var(--spacing-l);
    margin-left: calc(var(--spacing-xxs) * -2);
  }

  // The 1st marks always shows as active
  :first-of-type {
    left: calc(var(--spacing-xxs) * 2);
  }

  :last-of-type {
    left: auto;
    right: calc(var(--spacing-xxs) * 2);
  }
`;

type MarkProps = {
  value?: string;
  white: boolean;
  left: string;
  infinite?: boolean;
};

const Mark: FC<MarkProps> = ({ value, white, left, infinite }) => {
  return (
    <MarkContainer left={left} white={white || !value}>
      <Label variant={1}>{value}</Label>
    </MarkContainer>
  );
};

type MarksProps = {
  intervals: TPlanUsageInterval[];
  maxValue: number;
  value: number;
};

export const Marks: FC<MarksProps> = ({ intervals, maxValue, value }) => {
  return (
    <>
      <Mark white left={getAbsoluteWidth(0, maxValue)} />
      {intervals.map((interval) => (
        <Mark
          key={`mark_${interval.price}`}
          value={interval.label}
          white={value >= interval.max}
          left={getAbsoluteWidth(interval.max, maxValue)}
        />
      ))}
    </>
  );
};
